import { Action, createReducer, on } from '@ngrx/store';
import * as fromStaticDataProductSolutionsActions from '../actions/static-data-product-solutions.actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const staticDataProductSolutionsFeatureKey = 'staticDataProductSolutions';

export interface StaticDataProductSolutionsState {
  loadStaticDataProductSolutionsResponse: IStaticDataResponse[];
  loadStaticDataProductSolutionsFailure: any;
  loaded: boolean;
}

export const initialState: StaticDataProductSolutionsState = {
  loadStaticDataProductSolutionsResponse: undefined,
  loadStaticDataProductSolutionsFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataProductSolutionsActions.loadStaticDataProductSolutionsSuccess, (state, action) => ({
    ...state,
    loadStaticDataProductSolutionsResponse: action.response,
    loaded: true
  })),

  on(fromStaticDataProductSolutionsActions.loadStaticDataProductSolutionsFailure, (state, action) => ({
    ...state,
    loadStaticDataProductSolutionsFailure: action.error
  }))
);

export const getStaticDataProductSolutions = (state: StaticDataProductSolutionsState) => state.loadStaticDataProductSolutionsResponse;
